<template>
  <div>

    <div data-animation="default" data-collapse="medium" data-duration="400" data-easing="ease" data-easing2="ease" role="banner" class="navbar-component _2 w-nav">
      <div class="navbar-container w-container">
        <a id="w-node-_2bc7849c-fc53-2a49-059f-aa960ee8e78d-0ee8e78b" @click="goToHome" class="navbar-logo-link no-rizer w-nav-brand"><img src="../../../../../public/images/Logo.svg" loading="lazy" alt="" class="navbar-logo"></a>
      </div>
    </div>
    <div class="section color mid-line">
      <div class="container last form one w-container">
        <div class="form-regidet w-form">
          <div class="wrap-steps">
            <a @click="previousPage" class="arrow-left w-inline-block"><img src="../../../../../public/images/Union.svg" loading="lazy" alt="" class="arrow"></a>
            <div class="step">
              <div class="step-number like">
                <div>1</div>
              </div>
            </div>
            <div class="step">
              <div class="step-number active">
                <div class="text-block-9">2</div>
                <div data-w-id="a1680b49-2005-863e-9cc8-d83ed7d2e3cb" class="pulse"></div>
              </div>
            </div>
          </div>
          <form name="wf-form-signup-2" data-name="signup" method="get" data-ms-form="signup" class="form-input-regidet">
            <div class="form-progress-bar">
              <h1 v-if="!finalCountdownStarted" class="heading-form">Проверка данных</h1>
              <h1 v-else class="heading-form">Ваша заявка принята!</h1>
              <div class="lotti-number">

                <div ref="animationContainer" style="width: 250px; height: 250px;"></div>

                <div class="progress-bar">
                  <!-- Показываем проценты до завершения анимации, галочку после -->
                  <span v-if="!isAnimationComplete">{{ Math.floor(progress) }}%</span>
                  <svg v-else class="checkmark" width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M20 40L34 55L62 25" stroke="#4CAF50" stroke-width="6" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </div>
              </div>
              <div v-if="!finalCountdownStarted" class="text-classic _2">Не закрывайте вкладку и не уходите с нее.</div>

              <div v-else class="text-classic _2">
                Подобрали для вас подходящие предложения
                <!-- Через <span class="time-down">{{ finalCountdown }}</span> секунд покажем результат -->
              </div>
            </div>
            <div class="line-progress step-4"></div>
          </form>
        </div>
      </div>
    </div>

    <Footer />

  </div>
</template>

<script>
import { Footer } from '/src/app/shared/components';
import loadjs from 'loadjs';
import lottie from 'lottie-web';
// Путь к вашему файлу анимации
import animationData from '/public/documents/AnimationLoad.json';

export default {
  name: 'RegistrationStep4',
  data() {
    return {
      progress: 0,
      showProgressBar: false,
      countdown: 5, // Начальное значение обратного отсчета
      animationDuration: 5000, // Длительность анимации в миллисекундах
      finalCountdown: 4, // Обратный отсчет после завершения анимации
      finalCountdownStarted: false, // Флаг для начала финального обратного отсчета
      isAnimationComplete: false, // Флаг для отображения галочки
    };
  },
  components: {
    Footer
  },
  mounted() {
    /* грузим jquery и webflow */
    loadjs(
        "https://d3e54v103j8qbb.cloudfront.net/js/jquery-3.5.1.min.dc5e7f18c8.js?site=652921c910bae02d8870dddf",
        {
          success: () => {
            loadjs('./js/webflow.js', {
              success: () => {
              },
              error: () => {
                console.error('Failed to load Webflow');
              }
            });
          },
          error: () => {
            console.error('Failed to load jQuery');
          }
        }
    );

    /* счётчик для процентов и т.п. фигни */
    const scriptUrl = 'https://cdn.jsdelivr.net/npm/@finsweet/attributes-numbercount@1/numbercount.js';
    if (!document.querySelector(`script[src="${scriptUrl}"]`)) {
      const script = document.createElement('script');
      script.async = true;
      script.src = scriptUrl;
      document.head.appendChild(script);
    }

    this.loadAnimation();
  },
  computed: {
  },
  methods: {
    goToLogin() {
      this.$router.push('/login');
    },
    goToHome() {
      this.$router.push('/');
    },
    previousPage() {
      this.$router.push('/registration-step3');
    },
    goToPartners() {
      this.$router.push('/');
    },
    loadAnimation() {
      const options = {
        container: this.$refs.animationContainer,
        renderer: 'svg',
        loop: false,
        autoplay: true,
        animationData: animationData,
      };

      let animation = lottie.loadAnimation(options);

      const defaultDuration = 2;
      const desiredDuration = this.animationDuration / 1000;
      const speed = defaultDuration / desiredDuration;
      animation.setSpeed(speed);

      this.showProgressBar = true;

      this.updateProgress();
      this.startCountdown();

      animation.addEventListener('complete', () => {
        animation.goToAndStop(animation.totalFrames - 1, true); // Остановить анимацию на последнем кадре
        this.onAnimationComplete();
      });
    },
    updateProgress() {
      const startTime = Date.now();
      const interval = setInterval(() => {
        const elapsedTime = Date.now() - startTime;
        this.progress = Math.min(100, (elapsedTime / this.animationDuration) * 100);

        if (this.progress >= 100) {
          clearInterval(interval);
          this.isAnimationComplete = true; // Устанавливаем флаг для отображения галочки
          this.onAnimationComplete();
        }
      }, 100);
    },
    startCountdown() {
      const countdownInterval = setInterval(() => {
        this.countdown -= 1;
        if (this.countdown <= 0) {
          clearInterval(countdownInterval);
        }
      }, 1000);
    },
    onAnimationComplete() {
      this.finalCountdownStarted = true;
      this.startFinalCountdown();
    },
    regDone() {
      // Получаем параметры из Vue Router
      const queryString = this.$router.resolve({
        path: '/',
        query: this.$route.query
      }).href.split('?')[1] || ''

      // Сначала переходим на главную текущего сайта
      this.$router.push({
        path: '/',
        query: this.$route.query,
        replace: true
      }).then(() => {
        // Формируем URL с обязательным aff_sub1=vsemzaymi
        const url = `https://crapinka.ru/cXyjbhq7?aff_sub4=showcase&aff_sub1=vsemzaymi${queryString ? `&${queryString}` : ''}`;
        console.log(url);
        window.location.href = url;
      });
    },
    startFinalCountdown() {
      const finalCountdownInterval = setInterval(() => {
        this.finalCountdown -= 1;
        if (this.finalCountdown <= 0) {
          clearInterval(finalCountdownInterval);
          this.showProgressBar = false;
          // Отрпавка номера телефона на сервер
          this.regDone();
        }
      }, 1000);
    },
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      window.scrollTo(0, 0);
    });
  },
};
</script>

<style>
/* Стили для галочки */
.progress-bar .checkmark {
  animation: checkmarkAppear 0.5s cubic-bezier(0.34, 1.56, 0.64, 1);
  display: inline-block;
  vertical-align: middle;
}

@keyframes checkmarkAppear {
  0% {
    opacity: 0;
    transform: scale(0) rotate(-30deg);
  }
  100% {
    opacity: 1;
    transform: scale(1) rotate(0deg);
  }
}

/* Эффект рисования галочки */
.progress-bar .checkmark path {
  stroke-dasharray: 100;
  stroke-dashoffset: 100;
  animation: drawCheck 0.5s ease forwards 0.2s;
}

@keyframes drawCheck {
  to {
    stroke-dashoffset: 0;
  }
}
</style>